import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("leadify_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  const divId = localStorage.getItem("leadify_selected_division");
  if (divId) cfg.headers["X-Division-Id"] = divId;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config.url?.includes("/auth/")) {
      const superToken = localStorage.getItem("leadify_super_token");
      localStorage.removeItem("leadify_super_token");
      localStorage.removeItem("leadify_impersonating");
      localStorage.removeItem("leadify_user");
      if (superToken) {
        localStorage.setItem("leadify_token", superToken);
        window.location.href = "/admin";
        return Promise.reject(err);
      }
      localStorage.removeItem("leadify_token");
      if (window.location.pathname !== "/login" && !window.location.pathname.startsWith("/book/") && !window.location.pathname.startsWith("/chat/")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatCurrency(value, currency = "USD") {
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 0 }).format(value || 0);
  } catch (e) {
    return `${currency} ${(value || 0).toFixed(0)}`;
  }
}

export function relTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString();
}

export default api;
